import React from 'react';
import OrderWeb from 'components/Tvendo/Sale/Operations/OrderWebMovil/OrderWebMovil.js';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <OrderWeb
      type="W"
      title="retenidos web"
      permission={{
        show: ConstantPermissions.ORDM_ORDERS_SHOW,
        store: '',
        annular: ConstantPermissions.ORDM_ORDERS_ANNULAR_RETAINED_ORDER,
        approve: ConstantPermissions.ORDM_ORDERS_APPROVE_RETAINED_ORDER
      }}
    />
  );
}
